<template>
  <div class="space-y-6">
    <div>
      <h1 class="text-3xl font-bold tracking-tight">Blacklist</h1>
      <p class="text-muted-foreground">
        Manage symbols to exclude from analysis and recommendations.
      </p>
    </div>
    
    <BlacklistManager />
  </div>
</template>

<script setup lang="ts">
import BlacklistManager from '@/components/BlacklistManager.vue'
</script>
